import React from "react";
import i18n from "~/assets/js/Helpers/i18n";
import { User } from "react-feather";
import Button from "~/assets/js/components/Button";
import PropTypes from "prop-types";

const CancelGroupOrderBanner = ({ setCancelGroupOrder }) => {
    return (
        <div className="cancel-order">
            <div className="cancel-order__info">
                <User size={32} />
                <div className="cancel-order__description">
                    <p className="cancel-order__title">
                        {i18n.t("memberGroupOrder.cancelGroupOrder.title")}
                    </p>
                    <p className="cancel-order__subtitle">
                        {i18n.t("memberGroupOrder.cancelGroupOrder.subTitle")}
                    </p>
                </div>
            </div>
            <Button
                onClick={() => setCancelGroupOrder(true)}
                label={i18n.t("memberGroupOrder.cancelButton")}
                customStyle={"cancel-order__button"}
                variant="secondary"
                size="XS"
            />
        </div>
    );
};

CancelGroupOrderBanner.propTypes = {
    setCancelGroupOrder: PropTypes.func,
};

export default CancelGroupOrderBanner;
